(function () {
var $, ref, ref1, ref2, storageExists,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

$ = (ref = (ref1 = (ref2 = window.hs) != null ? ref2.jQuery : void 0) != null ? ref1 : window.hsjQuery) != null ? ref : window.jQuery;

if (window.hubspot == null) {
  window.hubspot = {};
}

storageExists = false;

try {
  storageExists = Boolean(window.localStorage && window.localStorage.setItem);
} catch (undefined) {}

window.hubspot.Interframe = (function() {
  function Interframe(remoteDomain, window1, json) {
    this.remoteDomain = remoteDomain;
    this.window = window1;
    this.json = json != null ? json : true;
    this.onMessage = bind(this.onMessage, this);
    this.callbacks = {};
    this.deferreds = {};
    this.queue = [];
    this.idIncrement = 0;
  }

  Interframe.prototype.start = function() {
    window.addEventListener('message', this.onMessage, false);
    return this;
  };

  Interframe.prototype.stop = function() {
    window.removeEventListener('message', this.onMessage, false);
    return this;
  };

  Interframe.prototype.postMessage = function(message, callback) {
    var deferred;
    deferred = $.Deferred();
    if (message.response && message._callbackId) {
      message.response._end = +new Date();
      message.response._start = message._start;
    } else {
      message._start = +new Date();
      this.idIncrement++;
      message._callbackId = this.idIncrement;
      this.deferreds[message._callbackId] = deferred;
      if ($.isFunction(callback)) {
        this.callbacks[message._callbackId] = callback;
      }
    }
    if (this.loading) {
      this.queue.push(message);
    } else {
      this._send(message);
    }
    return deferred.promise();
  };

  Interframe.prototype._send = function(message) {
    var serialized;
    serialized = this.json ? JSON.stringify(message) : message;
    this.log('Posting message to ' + this.remoteDomain);
    this.log(serialized);
    return this.window.postMessage(serialized, this.remoteDomain);
  };

  Interframe.prototype.onMessage = function(e) {
    var error, message, validMessage;
    validMessage = false;
    if (this.json) {
      try {
        message = JSON.parse(e.data);
        if ($.isPlainObject(message)) {
          validMessage = true;
        }
      } catch (error) {
        e = error;
        message = e.data;
      }
    } else {
      validMessage = true;
      message = e.data;
    }
    if (!validMessage) {
      this.log("Invalid message received");
      this.log(e.data);
      return;
    }
    this.log("Received message from " + e.origin);
    this.log(e.data);
    if ($.isPlainObject(message) && message.response && message._callbackId) {
      if (this.callbacks[message._callbackId]) {
        this.callbacks[message._callbackId](message.response);
        delete this.callbacks[message._callbackId];
      }
      if (this.deferreds[message._callbackId]) {
        this.deferreds[message._callbackId].resolve(message.response);
        delete this.deferreds[message._callbackId];
      }
    }
    return $(this).trigger('message', message);
  };

  Interframe.prototype.log = function(message) {
    if (storageExists && (typeof localStorage !== "undefined" && localStorage !== null ? localStorage.getItem('INTERFRAME_DEBUG') : void 0) && (window.console != null) && (window.console.log != null)) {
      return console.log("[Interframe] " + message);
    }
  };

  Interframe.prototype.setLoading = function(loading) {
    var message, results;
    this.loading = loading;
    if (!this.loading) {
      results = [];
      while (message = this.queue.shift()) {
        results.push(this._send(message));
      }
      return results;
    }
  };

  return Interframe;

})();
}());

